import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpResponse,
  HttpErrorResponse,
} from '@angular/common/http';
import { AnalyticsService } from '../analytics/analytics.service';
import { AuthService } from '../../core/auth/auth.service';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { DiagnosticsService } from '../diagnostics/diagnostics.service';

import has from 'lodash/has';
import each from 'lodash/each';

@Injectable({
  providedIn: 'root',
})
export class HttpInterceptorService implements HttpInterceptor {
  private _importantServices: string[] = [
    // 'api/bump/sync/',             // WS order sync
    'api/bump/orders/list', // POLLING
    'api/bump/orders', // Update ETA, Bump status and PRINTED
    'api/online/store/calendar', // Opening hours
    'api/bump/login', // Login
  ];

  constructor(public analytics: AnalyticsService, public auth: AuthService, public diagnostics: DiagnosticsService) {}

  /**
   * Intercept HTTP calls to track HTTPErrorResponse and log
   * @param req The request payload
   * @param next The callback function
   */
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      tap(
        response => {
          if (response instanceof HttpResponse) {
            if (has(response, 'body')) {
              // intercept ping if having server issues
              if (this.diagnostics.serverIssue) {
                each(this._importantServices, (service: string) => {
                  if (req.url.includes(service)) {
                    this.diagnostics.stopPing();
                    return false;
                  }
                });
              }
            }
          }
        },
        err => {
          if (err instanceof HttpErrorResponse) {
            // intercept errors
            each(this._importantServices, (service: string) => {
              if (req.url.includes(service)) {
                // send a ping
                this.diagnostics.ping();

                this.analytics.trackEvent(
                  'HTTP Interceptor Err',
                  `SERVICE: ${service} ERR: ${err.message}`,
                  this.auth.Tracking_key,
                );
                return false;
              }
            });
          }
        },
      ),
    );
  }
}
